import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE, ACCOUNT_TYPE } from '../constants';
import { handleDataDomeResponse, handleError } from './common';
import { otpCode, fetch_csrf_protect } from '../utils';
import { saveAuthenticatorAction } from './authenticator';
/*
 Actions
 */
export function initVerificationAction(data) {
	return {
		type: 'INIT_VERIFICATION',
		data: data
	}
}

export function resetVerificationAction(data) {
	return {
		type: 'RESET_CURRENT_VERIFICATION_ACTION',
		data: data
	}
}

export function getCodeAction(data) {
	return {
		type: 'GET_CODE',
		data: data
	}
}

export function verifyCodeAction(data) {
	return {
		type: 'VERIFY_CODE',
		data: data
	}
}

function setLoading(loading) {
	return {
		type: 'SET_LOADING',
		data: { loading },
	}
}

export function setError(err) {
	return {
		type: 'SET_ERR',
		data: { err },
	}
}

export function setToast(toast) {
	return {
		type: 'SET_TOAST',
		data: { toast }
	}
}

function fetchDataDomeCSRFProtect(url, options) {
	return (function resend() {
		return fetch_csrf_protect(url, {
			...options,
			headers: {
				...options.headers,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		}).then(handleDataDomeResponse(resend));
	})();
}

/*
 Async functions
 */
export function getCode(mobile_no, by_email, locale, template_id, template_params, gateway) {
	var data = {};
	if (mobile_no) data.mobile_no = mobile_no;
	if (by_email) data.by_email = by_email;
	if (locale) data.locale = locale;
	if (template_id) data.template_id = template_id;
	if (template_params) data.params = template_params;
	if (gateway) data.gateway = gateway;
	return dispatch => {
		dispatch(setLoading(true));
		fetchDataDomeCSRFProtect('/api/account/code/get', {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(data),
		}).then((data) =>
			handleGetCode(dispatch, {
				...data,
				gateway: !by_email ? gateway || 'sms_gateway' : undefined,
			})
		);
	}
}

export function submitCode(code, ac_type, tool) {
	var api_url = '/api/account/code/verify';
	return (dispatch, getState) => {
		const state = getState();
		const { gateway } = state.verification;

		if (ac_type == ACCOUNT_TYPE.OTPTOKEN) {
			api_url = '/api/account/code/revoke_token';
		} else if (ac_type == ACCOUNT_TYPE.AUTHENTICATOR) {
			const { userInfo } = state.data;
			if (userInfo.authenticator_enable) {
				api_url = '/api/account/authenticator/revoke'
			}
		}
		fetchDataDomeCSRFProtect(api_url, {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify({
				code: code,
				ac_type: ac_type,
				tool: tool,
				gateway: gateway,
			})
		})
			.then(data => handleSubmitCode(dispatch, data))
	}
}

/*
 Helper functions
 */
function handleGetCode(dispatch, data) {
	if ('error' in data) {
		if (data.error === 'error_no_account') {
			dispatch(setError('no_acc'));
		} else {
			handleError(data);
		}
	} else {
		dispatch(getCodeAction(data));
		if (data.status === 0) {
			if (data.gateway) {
				dispatch(setToast(data.gateway));
			}
			otpCode();
		}
	}
	dispatch(setLoading(false));
}

function handleSubmitCode(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	if (data.status == 0) {
		// reset current action in verification
		dispatch(resetVerificationAction(data));
		// verify successful, redirect to next action
		switch (data.next_action.action_type) {
			case ACTION_TYPE.APPLY_MOBILE:
				browserHistory.push('/security/mobile/apply');
				break;
			case ACTION_TYPE.SAVE_EMAIL:
				browserHistory.push('/security/email/save');
				break;
			case ACTION_TYPE.CHANGE_PASSWORD:
				browserHistory.push('/security/password/change');
				break;
			case ACTION_TYPE.SAVE_GAME_OTP:
				browserHistory.push('/security/game_otp/save');
				break;
			case ACTION_TYPE.SAVE_AUTHENTICATOR:
				dispatch(saveAuthenticatorAction(data));
				browserHistory.push('/security/authenticator/save');
				break;
			case ACTION_TYPE.SAVE_REALINFO:
				browserHistory.push('/security/realinfo/save');
				break;
			case ACTION_TYPE.UPDATE_REALINFO:
				browserHistory.push('/security/realinfo/update');
				break;
			case ACTION_TYPE.DONE_REVOKE:
				browserHistory.push('/security/authenticator/done_revoke');
				break;
			case ACTION_TYPE.DONE:
				browserHistory.push('/security/otp_revoke/done');
				break;
			default:
				break;
		}
	}
	dispatch(verifyCodeAction(data));
}



// WEBPACK FOOTER //
// ./app/actions/verification.js